/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const SearchV2 = (props: any) => (
<svg {...props} width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Frame 2854">
<circle id="Ellipse 124" cx="67.8625" cy="67.8616" r="52.1379" fill="#D7DCE6"/>
<circle id="Ellipse 133" cx="46.3461" cy="46.3442" r="41.3793" fill="white" fillOpacity="0.3" stroke="#A5A9B5" strokeWidth="9.93103"/>
<line id="Line 76" x1="79.8504" y1="80.2754" x2="106.759" y2="107.184" stroke="#A5A9B5" strokeWidth="9.93103" strokeLinecap="round"/>
<path id="Vector 61" d="M66.2074 20.6896C58.9848 20.6896 52.966 14.6708 52.966 7.44824C52.966 14.6708 46.9472 20.6896 39.7246 20.6896C46.9472 20.6896 52.966 26.7084 52.966 33.931C52.966 26.7084 58.9848 20.6896 66.2074 20.6896Z" fill="white"/>
</g>
</svg>
);

export default SearchV2;